import angular from 'angular';
import loadCartComponent from './load-cart.component';
import loadCartConfig from './load-cart.config';

let loadCartModule = angular.module('app.loadCart',[])
  .component('loadCart', loadCartComponent)
  .config(loadCartConfig);

export default loadCartModule;


/** WEBPACK FOOTER **
 ** ./www/components/load-cart/load-cart.js
 **/